<template>
  <div class="referral-coupon-section">
    <current-plan-card-section :plan="baseCouponPlan" :isConfirmed="true" />
    <p v-if="false" class="referral-coupon-section__about">
      <atom-link
        url="#"
        :disableTextDecoration="false"
        :isOpenAsBlank="true"
        :link-text="$tc('MypagePage.MypageReferralCode.aboutReferralCode')"
        :imgPath="require('@/assets/img/icon/icon_external_link_gray.svg')"
      />
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import CurrentPlanCardSection from '@/components/SignupPage/common/CurrentPlanCardSection.vue'
import AtomLink from '@/components/atoms/AtomLink.vue'
import ContractPlanDocument from '@/store/stores/collectionModule/documents/plan/ContractPlanDocument'

/**
 * マイページ: 紹介コード: 適用クーポン表示セクション
 */
export default defineComponent({
  name: 'ReferralCouponSection',
  components: {
    CurrentPlanCardSection,
    AtomLink,
  },
  props: {
    baseCouponPlan: {
      type: Object as PropType<ContractPlanDocument>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.referral-coupon-section {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  margin: 0 auto;
  text-align: center;
}
</style>

<style lang="scss">
.referral-coupon-section {
  .current-plan-card-section {
    padding-top: 0;
  }
}
</style>
